import { render } from "./PimProductsOverviewTilesItem.vue?vue&type=template&id=54920c25&scoped=true&ts=true"
import script from "./PimProductsOverviewTilesItem.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewTilesItem.vue?vue&type=script&lang=ts"

import "./PimProductsOverviewTilesItem.vue?vue&type=style&index=0&id=54920c25&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54920c25"]])

export default __exports__